var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wscn-http404-container"},[_c('img',{staticStyle:{"width":"100px"},attrs:{"src":"https://gaoduan.qn.zhongboyq.com/logo512.png","alt":"404"}}),_c('div',{staticClass:"bullshit"},[_c('div',{staticClass:"bullshit__info",staticStyle:{"color":"#3b3e77","font-size":"96px","margin-left":"20px"}},[_vm._v(" 404 ")])])])
}]

export { render, staticRenderFns }